import React, { Component } from 'react';
import Aux from '../../../components/Hoc/Aux';
import Reasons from '../../../components/Reasons/ReasonsSmallBizMarket';
import Testimonials from '../../../components/Testimonials/Testimonials';

class SmallBusinessMarket extends Component {
  componentDidMount () {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'visitorType': 'Group',
      'event': 'GAEvent',
      'eventCategory': 'View',
      'eventAction': 'Landing',
      'eventLabel': 'Plans - Hudson Valley',
      'eventValue': undefined
    });
  }

  render () {
    return (
      <Aux>
        <Reasons tab={this.props.tab} />
        <Testimonials heading='“CDPHP checks all the boxes, and we couldn’t be happier with our experience.”' slides='smallbiz' smallBiz='true' />
      </Aux>
    );
  }
}

SmallBusinessMarket.propTypes = { // validate props expected
};

export default SmallBusinessMarket;



// WEBPACK FOOTER //
// ./src/containers/Views/Landing/SmallBusinessMarket.jsx